import type { Comment } from '../api/types';

/** Merge socket/HTTP comment updates — keeps the richest asset list when ids match. */
export function upsertComment(prev: Comment[], incoming: Comment): Comment[] {
  const existingIndex = prev.findIndex((c) => c.id === incoming.id);
  if (existingIndex < 0) {
    return [...prev, incoming];
  }

  return prev.map((c, index) => {
    if (index !== existingIndex) return c;
    const assets =
      incoming.assets.length >= c.assets.length ? incoming.assets : c.assets;
    return { ...c, ...incoming, assets };
  });
}
